import {
  InstantUploadMultiFileField,
  InstantUploadMultiFileFieldProps,
} from '@components/instant-upload-file-field/instant-upload-multi-file-field';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormInstantUploadMultiFileFieldProps<T> = FormFieldProps<
  InstantUploadMultiFileFieldProps,
  T
>;

export function FormInstantUploadMultiFileField<T>(props: FormInstantUploadMultiFileFieldProps<T>) {
  const formFieldProps = useFormField(props);

  return <InstantUploadMultiFileField {...props} {...formFieldProps} />;
}
